<template>
    <nav>
        <Aside :toggle="collapsed" :location="'topnav'" :data="modules"
            @onchange="(obj) => collapsed = obj['collapsed']"></Aside>
        <div class="row">
            <div class="menu flex vcenter">
                <div class="toggle">
                    <i class="fe fe-16 fe-menu" @click.prevent="collapsed = !collapsed"></i>
                </div>
                <div class="brand">
                    <img v-if="logo" v-lazy="'/images/hlogo.webp'" alt="آتیاکراد" loading="lazy" />
                </div>
                <div class="right flex wrap center">
                    <div class="option">
                        <ul class="flex wrap center vcenter">
                            <template v-for="(menu, index) in modules['menus']" :key="index">
                                <li v-if="!modules['options'].find(option => option.menu === menu.id)"><a
                                        :href="menu.route" @click.prevent="route(menu.extras, menu.route)">{{
                                            menu.name }}</a></li>
                                <li v-else>
                                    <div class="dropdown">
                                        <a :href="menu.route" class="flex vcenter"
                                            @click.prevent="route(menu.extras, menu.route)">{{
                                                menu.name }} <i class="fe fe-chevron-down fe-16"></i></a>
                                        <div class="items wrap">
                                            <template v-for="(option, index) in modules['options']
                                                .filter((option) => { return option.menu === menu.id })" :key="index">
                                                <a :href="option.route"
                                                    @click.prevent="route(option.extras, option.route)">{{ option.name
                                                    }}</a>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="left flex wrap end vcenter">
                    <span>شماره مجوز: 13633625</span>
                    <a :href="portal['href']">
                        <button>{{ portal['content'] }}</button>
                    </a>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
/* eslint-disable */
import Aside from './Aside.vue'

export default {
    name: 'Header',
    components: { Aside },
    inject: ['base'],
    created() {
        this.collapsed = true
        this.base.API().get('Addons/Option/Nav', (response) => {
            if (this.base.Util().success(response))
                if (this.base.Util().validate(response.data.menus)) {
                    this.modules['menus'] = response.data.menus
                    if (this.base.Util().validate(response.data.options))
                        this.modules['options'] = response.data.options

                    localStorage.setItem('nav', JSON.stringify([this.modules]))
                }
        })

        if (this.$cookies.get('identifier')) {
            this.portal['href'] = '/Dashboard'
            this.portal['content'] = 'حساب کاربری'
        }

        if (window.screen.width <= 460)
            this.logo = false
    },
    data() {
        return {
            logo: true,
            collapsed: false,
            modules: eval(localStorage.getItem('nav') || [{ categories: [{ id: 0, name: '' }], menus: [], options: [] }])[0]
                || { categories: [{ id: 0, name: '' }], menus: [], options: [] },
            portal: {
                href: '/Authentication',
                content: 'ثبت نام / ورود'
            }
        }
    },
    watch: {
        display_name(newDisplayName, oldDisplayName) {
            if (this.$cookies.get('identifier')) {
                this.portal['href'] = '/Dashboard'
                this.portal['content'] = 'حساب کاربری'
            } else {
                this.portal['href'] = '/Authentication'
                this.portal['content'] = 'ثبت نام / ورود'
            }
        }
    },
    methods: {
        route(extras, route) {
            let extra = this.base.Entities().parse(extras)
            if (extra['params'])
                route = route.replace(`{${extra['params']}}`, this.$cookies.get(extra['params']))

            if (!extra['type'] || extra['type'] === 'route') {
                let hash = ''
                let query = {}
                if (String(route).includes('?'))
                    String(route).split('?')[1].split('&').forEach((q) => {
                        query[q.split('=')[0]] = q.split('=')[1] || ''
                    })
                if (String(route).includes('#'))
                    hash = `#${route.split('#')[1]}`
                this.$router.push({ path: route, query: query, hash: hash })
            }
            else if (extra['type'] === 'newtab')
                window.open(route)
            else if (extra['type'] === 'action')
                if (route === 'logout')
                    this.base.Security().logout(['/dashboard'])

            if (this.fullscreen)
                this.collapsed = true
        }
    }
}
</script>

<style src="../assets/css/components/header.css"></style>